// Central data-testid registry for SchoolXpert360.
export const HOME = {
	emergentLink: 'home-emergent-link',
};

export const NAV = {
	navbar: 'main-navbar',
	brand: 'nav-brand-logo',
	themeToggle: 'nav-theme-toggle',
	ctaButton: 'nav-cta-button',
	mobileMenuButton: 'nav-mobile-menu-button',
};

export const HERO = {
	headline: 'hero-headline',
	consultationCta: 'hero-consultation-cta',
	badgeAdmission: 'badge-100-admission-assurance',
	badgePreschool: 'badge-50-preschool-assurance',
};

export const SERVICES = {
	grid: 'services-grid',
	card: (id) => `service-card-${id}`,
};

export const LEAD_FORM = {
	form: 'multi-step-lead-form',
	step: (n) => `multi-step-form-step-${n}`,
	next: 'multi-step-next-button',
	prev: 'multi-step-prev-button',
	submit: 'multi-step-submit-button',
	fullName: 'lead-full-name-input',
	phone: 'lead-phone-input',
	email: 'lead-email-input',
	schoolName: 'lead-school-name-input',
	city: 'lead-city-input',
	state: 'lead-state-input',
	schoolType: 'lead-school-type-select',
	requirement: 'lead-requirement-select',
	studentStrength: 'lead-student-strength-input',
	admissionTarget: 'lead-admission-target-input',
	message: 'lead-message-input',
	callTime: 'lead-call-time-input',
	consent: 'lead-consent-checkbox',
	honeypot: 'lead-company-website-hp',
	progress: 'multi-step-progress',
};

export const SUCCESS = {
	screen: 'thank-you-success-screen',
	checkmark: 'thank-you-checkmark-anim',
	close: 'thank-you-close-button',
};

export const FLOAT = {
	button: 'sticky-consultation-float-btn',
};

export const CONTACT = {
	submit: 'contact-form-submit',
};

export const SYNC = {
	status: 'backend-sheets-sync-status',
};
